/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Generated on Tuesday, June 24, 2025 9:10:01 PM UTC
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IInternalProjectsInputCreate,
  IInternalProjectsInputGeneralSettings,
  IInternalProjectsInputManageCustomFilter,
  IInternalProjectsInputCreateDescriptionTemplate,
  IInternalProjectsInputUpdateCustomFilter,
  IInternalProjectsInputUpdateDescriptionTemplate,
  IInternalProjectsInputChangeWorkflow,
  IInternalProjectsInputChecklistTemplateCreate,
  IInternalProjectsInputChecklistTemplateUpdate,
} from '../types/request.types'
import {
  IItemForSelection,
  IProjectsOutputNote,
  ILastUpdatedEpochTime,
  IProjectWithWorkflow,
  IProjectsOutputAssignPeople,
  IPersonWithEmail,
  IProjectsOutputMyNotifications,
  IPriorityLevelForSelection,
  IStatusForSelection,
  IPersonBase,
  IInternalProjectsOutputUpdatableInternalProjects,
  IProjectsOutputIntegrations,
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogs,
  ILimitCheck,
  IProjectForSelection,
  IWorkflowForSelection,
  IInternalProjectsOutputDetail,
  IWorkflowDetailStatusTransition,
  IInternalProjectsOutputDescriptionTemplates,
  IInternalProjectsOutputGeneralSettings,
  IInternalProjectsOutputFilterOptionsForListing,
  IInternalProjectsOutputDefaultFilterOptionCounts,
  IProjectsOutputShowInfoPanelOnLanding,
  IGenericJSONMessage,
  IPostSuccess,
  IChecklistTemplate,
  IChecklist,
} from '../types/response.types'

export default new class InternalProjectsAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Title(
    internal_project_id: any,
  ): Promise<IItemForSelection> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/title`,
    })
  }
  public async get_Note(
    internal_project_id: any,
  ): Promise<IProjectsOutputNote> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/note`,
    })
  }
  public async get_MostRecentLastUpdatedEpochTime(
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/most-recent-last-updated-epoch-time`,
    })
  }
  public async get_LastUpdatedEpochTime(
    internal_project_id: any,
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/last-updated-epoch-time`,
    })
  }
  public async get_WithWorkflow(
    internal_project_id: any,
  ): Promise<IProjectWithWorkflow> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/with-workflow`,
    })
  }
  public async get_AssignPeople(
    internal_project_id: any,
  ): Promise<IProjectsOutputAssignPeople> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-people`,
    })
  }
  public async get_AssignGuests(
    internal_project_id: any,
  ): Promise<IProjectsOutputAssignPeople> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-guests`,
    })
  }
  public async get_Members(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/members`,
    })
  }
  public async get_MembershipCandidates(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/membership-candidates`,
    })
  }
  public async get_MyNotifications(
    internal_project_id: any,
  ): Promise<IProjectsOutputMyNotifications> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/my-notifications`,
    })
  }
  public async get_Assignees(
    internal_project_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assignees`,
    })
  }
  public async get_Priorities(
    internal_project_id: any,
  ): Promise<IPriorityLevelForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/priorities`,
    })
  }
  public async get_Statuses(
    internal_project_id: any,
  ): Promise<IStatusForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/statuses`,
    })
  }
  public async get_Creators(
    internal_project_id: any,
  ): Promise<IPersonBase[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/creators`,
    })
  }
  public async get_Tags(
    internal_project_id: any,
  ): Promise<IItemForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/tags`,
    })
  }
  public async get_UpdatableInternalProjects(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputUpdatableInternalProjects> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/updatable-internal-projects`,
    })
  }
  public async get_Integrations(
    internal_project_id: any,
  ): Promise<IProjectsOutputIntegrations> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations`,
    })
  }
  public async get_Index(
  ): Promise<IProjectsOutputProjectForHome[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects`,
    })
  }
  public async get_DailyActivityLogs(
  ): Promise<IProjectDailyActivityLogs> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/daily-activity-logs`,
    })
  }
  public async get_LimitCheck(
  ): Promise<ILimitCheck> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/limit-check`,
    })
  }
  public async get_ForSelection(
  ): Promise<IProjectForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/for-selection`,
    })
  }
  public async get_Workflows(
  ): Promise<IWorkflowForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/workflows`,
    })
  }
  public async get_Detail(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}`,
    })
  }
  public async get_WorkflowStatusTransitions(
    internal_project_id: any,
  ): Promise<IWorkflowDetailStatusTransition[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/workflow-status-transitions`,
    })
  }
  public async get_DescriptionTemplates(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDescriptionTemplates> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates`,
    })
  }
  public async get_GeneralSettings(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputGeneralSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/general-settings`,
    })
  }
  public async get_FilterOptionsForListing(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputFilterOptionsForListing> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/filter-options/listing`,
    })
  }
  public async get_DefaultFilterOptionCounts(
    internal_project_id: any,
  ): Promise<IInternalProjectsOutputDefaultFilterOptionCounts> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/default-filter-option-counts`,
    })
  }
  public async get_ShowInfoPanelOnLanding(
    internal_project_id: any,
  ): Promise<IProjectsOutputShowInfoPanelOnLanding> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/show-info-panel-on-landing`,
    })
  }
  public async get_ChecklistTemplates(
    internal_project_id: any,
  ): Promise<IChecklistTemplate[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates`,
    })
  }
  /****** POST methods *****/
  public async post_Archive(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/archive`,
    })
  }
  public async post_Delete(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/delete`,
    })
  }
  public async post_Restore(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/restore`,
    })
  }
  public async post_Favorite(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/favorite`,
    })
  }
  public async post_Unfavorite(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/unfavorite`,
    })
  }
  public async post_AssignPeople(
    internal_project_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/assign-people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async post_MyNotifications(
    internal_project_id: any,
    notificationOptionID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/my-notifications`,
      data: {
        notificationOptionID
      },
    })
  }
  public async post_SetSlackIntegration(
    internal_project_id: any,
    channelID: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/slack`,
      data: {
        channelID
      },
    })
  }
  public async post_RemoveSlackIntegration(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/slack/remove`,
    })
  }
  public async post_SetGlipIntegration(
    internal_project_id: any,
    apiToken: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/glip`,
      data: {
        apiToken
      },
    })
  }
  public async post_RemoveGlipIntegration(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/glip/remove`,
    })
  }
  public async post_SetHarvestEnabled(
    internal_project_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/integrations/harvest`,
      data: {
        enabled
      },
    })
  }
  public async post_Create(
    data: IInternalProjectsInputCreate,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects`,
      data,
    })
  }
  public async post_GeneralSettings(
    internal_project_id: any,
    data: IInternalProjectsInputGeneralSettings,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/general-settings`,
      data,
    })
  }
  public async post_CreateCustomFilter(
    internal_project_id: any,
    data: IInternalProjectsInputManageCustomFilter,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-filters`,
      data,
    })
  }
  public async post_CreateDescriptionTemplate(
    internal_project_id: any,
    data: IInternalProjectsInputCreateDescriptionTemplate,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates`,
      data,
    })
  }
  public async post_ChecklistTemplateCreate(
    internal_project_id: any,
    data: IInternalProjectsInputChecklistTemplateCreate,
  ): Promise<IChecklistTemplate> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates`,
      data,
    })
  }
  public async post_ChecklistTemplateAddToTask(
    internal_project_id: any,
    checklist_template_id: any,
    task_id: any,
  ): Promise<IChecklist> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}/add-to-task/${task_id}`,
    })
  }
  /****** PUT methods *****/
  public async put_RequestAccess(
    internal_project_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/request-access`,
    })
  }
  public async put_Title(
    internal_project_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/title`,
      data: {
        name
      },
    })
  }
  public async put_UpdateCustomFilter(
    internal_project_id: any,
    custom_filter_id: any,
    data: IInternalProjectsInputUpdateCustomFilter,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/custom-filters/${custom_filter_id}`,
      data,
    })
  }
  public async put_UpdateDescriptionTemplate(
    internal_project_id: any,
    description_template_id: any,
    data: IInternalProjectsInputUpdateDescriptionTemplate,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates/${description_template_id}`,
      data,
    })
  }
  public async put_AddPeople(
    internal_project_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async put_ChangeWorkflow(
    internal_project_id: any,
    data: IInternalProjectsInputChangeWorkflow,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/change-workflow`,
      data,
    })
  }
  public async put_Note(
    internal_project_id: any,
    description: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/note`,
      data: {
        description
      },
    })
  }
  public async put_ToggleJobs(
    internal_project_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/toggle-jobs`,
      data: {
        enabled
      },
    })
  }
  public async put_ChecklistTemplateUpdate(
    internal_project_id: any,
    checklist_template_id: any,
    data: IInternalProjectsInputChecklistTemplateUpdate,
  ): Promise<IChecklistTemplate> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_DeleteDescriptionTemplate(
    internal_project_id: any,
    description_template_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/description-templates/${description_template_id}`,
    })
  }
  public async delete_ChecklistTemplateDelete(
    internal_project_id: any,
    checklist_template_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/internal-projects/${internal_project_id}/checklist-templates/${checklist_template_id}`,
    })
  }
}()
